<template>
  <section class="bannerSlider-section editable">
    <swiper
      :pagination="{
        dynamicBullets: true,
      }"
      :loop="true"
      :lazy="true"
      :effect="'fade'"
      :autoplay="{
        delay: 2500,
        disableOnInteraction: true,
      }"
      :navigation="true"
      :modules="modules"
      class="bannerSlider"
      id="container"
    >
      <div class="theme-free-image"></div>
      <audio
        ref="audioElm"
        id="player"
        loop
        v-if="this.themeInfo?.info?.business?.music"
      >
        <!-- <source src="horse.ogg" type="audio/ogg" /> -->
        <source
          :src="'https://' + encodeURI(this.themeInfo?.info?.business?.music)"
          type="audio/mpeg"
        />
      </audio>
      <transition name="zoom">
        <template v-if="this.themeInfo?.info?.business?.music">
          <div
            v-if="playeAudio"
            @click="playeAudio = !playeAudio"
            class="autoplay-btn autoplay-pause"
          ></div>
          <div
            v-else
            @click="playeAudio = !playeAudio"
            class="autoplay-btn autoplay-play"
          ></div>
        </template>
      </transition>

      <swiper-slide>
        <div class="swiper-lazy style-default-banner"></div>
      </swiper-slide>

      <template v-if="themeInfo?.info?.business.banner_main != null">
        <swiper-slide>
          <img
            :src="themeInfo?.info?.business.banner_main"
            alt=""
            class="swiper-lazy"
          />
        </swiper-slide>
      </template>

      <template
        v-if="
          themeInfo?.info?.imageGallery.filter((el) => {
            return (el.showIn == 'banner') & (el.cat_id == 2);
          }).length > 0
        "
      >
        <swiper-slide
          v-for="(item, index) in themeInfo?.info?.imageGallery.filter((el) => {
            return (el.showIn == 'banner') & (el.cat_id == 2);
          })"
          :key="index"
        >
          <img :src="item.file" alt="" class="swiper-lazy" />
        </swiper-slide>
      </template>
      <swiper-slide
        v-else
        v-for="(item, index) in getbanners(
          this.themeInfo.template,
          this.themeInfo?.info?.business.banner_main
        )"
        :key="index"
      >
        <img :src="item.image" alt="" class="swiper-lazy" />
      </swiper-slide>

      <!-- <swiper-slide
        v-for="(item, index) in getbanners(styleName, '')"
        :key="index"
      >
        <img :src="item.image" alt="" class="swiper-lazy" />
      </swiper-slide> -->
    </swiper>
    <editBox
      :option="['edit']"
      :size="'large'"
      :item="'banner'"
      :itemId="0"
      displayMode="horizontal_center"
    />
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/lazy";
import { Autoplay, Pagination, Navigation, Lazy, EffectFade } from "swiper";
import { bannersData } from "@/repo/bannersData.js";
import { mapGetters } from "vuex";
import editBox from "@/components/editBox/index.vue";
export default {
  name: "bannerImageSlider",
  data() {
    return {
      playeAudio: false,
    };
  },
  watch: {
    playeAudio(newQuestion) {
      if (newQuestion === false) {
        console.log("pause");
        this.$refs.audioElm.pause();
      } else {
        this.$refs.audioElm.play();
        console.log("play");
      }
    },
  },
  mixins: [bannersData],
  components: {
    Swiper,
    SwiperSlide,
    editBox,
  },

  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
    }),
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation, Lazy, EffectFade],
    };
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/bannerImageSlider/bannerImageSlider.css);
</style>